import React from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// import InputLabel from '@material-ui/core/InputLabel';
import Face from '@material-ui/icons/Face';
import Security from '@material-ui/icons/Security';
import Group from '@material-ui/icons/Group';

// core components
import avatar from '../../assets/img/faces/avatar.png';
import GridItem from '../../components/Admin/Grid/GridItem';
import GridContainer from '../../components/Admin/Grid/GridContainer';
import CustomInput from '../../components/Admin/CustomInput/CustomInput';
import Button from '../../components/Admin/CustomButtons/Button';
import CustomTabs from '../../components/Admin/CustomTabs/CustomTabs';
import CardAvatar from '../../components/Admin/Card/CardAvatar';
import CardBody from '../../components/Admin/Card/CardBody';
import CardFooter from '../../components/Admin/Card/CardFooter';
import useViewer from '../../providers/Customer/useViewer';
import useUpdateCustomer from '../../providers/Customer/useUpdateCustomer';
import useUpdateNextOfKin from '../../providers/Customer/useUpdateNextOfKin';
import useUpdateCustomerPassword from '../../providers/Customer/useUpdateCustomerPassword';
import { PreLoader } from '../../components';

import { grayColor } from '../../assets/jss/material-dashboard-react';

const styles = {
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0',
  },
  cardCategory: {
    color: grayColor[2],
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0',
    borderBottom: `1px solid ${grayColor[10]}`,
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none',
  },
  cardTitle: {
    color: grayColor[2],
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none',
    '& small': {
      color: grayColor[1],
      fontWeight: '400',
      lineHeight: '1',
    },
  },
};

const useStyles = makeStyles(styles);

const required = true;

const ProfileTab = ({ viewer, classes }) => {
  const {
    _v,
    form: { text, email },
    handleSubmit,
    loading,
  } = useUpdateCustomer({ customer: viewer });
  return (
    <form onSubmit={handleSubmit}>
      <CardBody>
        <h3 className={classes.cardTitle}>Personalize</h3>
        <p className={classes.cardCategory}></p>
        <CardAvatar profile className="mt-5">
          <a href="#pablo" onClick={(e) => e.preventDefault()}>
            <img src={avatar} alt="..." />
          </a>
        </CardAvatar>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              labelText="First Name"
              id="first-name"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...text(_v.firstName), required }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              labelText="Last Name"
              id="last-name"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...text(_v.lastName), required }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={5}>
            <CustomInput
              labelText="Gender"
              id="gender"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...text(_v.gender), required }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Phone"
              id="phone"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...text(_v.phone), required }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Email address"
              id="email-address"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...email(_v.email), required, disabled: true }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              labelText="City"
              id="city"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...text(_v.city), required }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              labelText="State of Residence"
              id="state"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...text(_v.stateOfResidence), required }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <CustomInput
              labelText="Address"
              id="address"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...text(_v.address), required }}
            />
          </GridItem>
        </GridContainer>
      </CardBody>
      <CardFooter>
        {loading ? (
          <PreLoader />
        ) : (
          <Button color="primary" type="submit">
            Update Profile
          </Button>
        )}
      </CardFooter>
    </form>
  );
};

const NOKTab = ({ viewer, classes }) => {
  const {
    _v,
    form: { text, email },
    handleSubmit,
    nextOfKin,
    loading,
  } = useUpdateNextOfKin({ customer: viewer });
  return (
    <form onSubmit={handleSubmit}>
      <CardBody>
        <h3 className={classes.cardTitle}>Details</h3>
        <p className={classes.cardCategory}></p>
        {/* <CardAvatar profile className="mt-5">
        <a href="#pablo" onClick={(e) => e.preventDefault()}>
          <img src={avatar} alt="..." />
        </a>
      </CardAvatar> */}
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              labelText="First Name"
              id="first-name"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...text(_v.firstName), required }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              labelText="Last Name"
              id="last-name"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...text(_v.lastName), required }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={5}>
            <CustomInput
              labelText="Gender"
              id="gender"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...text(_v.gender) }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Phone"
              id="phone"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...text(_v.phone), required }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Email address"
              id="email-address"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...email(_v.email), required }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              labelText="City"
              id="city"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...text(_v.city) }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              labelText="State of Residence"
              id="state"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...text(_v.stateOfResidence) }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <CustomInput
              labelText="Address"
              id="address"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...text(_v.address) }}
            />
          </GridItem>
        </GridContainer>
      </CardBody>
      <CardFooter>
        {loading ? (
          <PreLoader />
        ) : (
          <Button color="primary" type="submit">
            {nextOfKin ? 'Update' : 'Create'} Details
          </Button>
        )}
      </CardFooter>
    </form>
  );
};

const SecurityTab = ({ viewer, classes }) => {
  const {
    _v,
    form: { password },
    handleSubmit,
    loading,
  } = useUpdateCustomerPassword({ customer: viewer });
  return (
    <form onSubmit={handleSubmit}>
      <CardBody>
        <h3 className={classes.cardTitle}>Password</h3>
        <p className={classes.cardCategory}>Change your password to a new one</p>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              labelText="Old Password"
              id="oldPassword"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...password(_v.oldPassword) }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              labelText="New Password"
              id="newPassword"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...password(_v.newPassword) }}
            />
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={6}>
            <CustomInput
              labelText="Confirm Password"
              id="confirmPassword"
              formControlProps={{
                fullWidth: true,
              }}
              inputProps={{ ...password(_v.confirmPassword) }}
            />
          </GridItem>
        </GridContainer>
      </CardBody>
      <CardFooter>
        {loading ? (
          <PreLoader />
        ) : (
          <Button color="primary" type="submit">
            Change Password
          </Button>
        )}
      </CardFooter>
    </form>
  );
};

export default function UserProfile() {
  const classes = useStyles();
  const { viewer } = useViewer();

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <CustomTabs
            title=""
            headerColor="primary"
            tabs={[
              {
                tabName: 'Account',
                tabIcon: Face,
                tabContent: <ProfileTab viewer={viewer} classes={classes} />,
              },
              {
                tabName: 'Next Of Kin',
                tabIcon: Group,
                tabContent: <NOKTab viewer={viewer} classes={classes} />,
              },
              {
                tabName: 'Security',
                tabIcon: Security,
                tabContent: <SecurityTab viewer={viewer} classes={classes} />,
              },
            ]}
          />
        </GridItem>
        {/* <GridItem xs={12} sm={12} md={4}>
          <Card profile>
            <CardAvatar profile>
              <a href="#pablo" onClick={(e) => e.preventDefault()}>
                <img src={avatar} alt="..." />
              </a>
            </CardAvatar>
            <CardBody profile>
              <h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>
              <h4 className={classes.cardTitle}>Alec Thompson</h4>
              <p className={classes.description}>
                Don{"'"}t be scared of the truth because we need to restart the human foundation in truth And I love you
                like Kanye loves Kanye I love Rick Owens’ bed design but the back is...
              </p>
              <Button color="primary" round>
                Follow
              </Button>
            </CardBody>
          </Card>
        </GridItem> */}
      </GridContainer>
    </div>
  );
}
